<template>
  <div>
    <registerUser></registerUser>
  </div>
</template>
<script>
import registerUser from "@/components/RegisterUser.vue";
export default {
  components: {
    registerUser
  },
  created: () => {},
  mounted(){
    this.$store.commit("SET_LAYOUT", "home-layout");
  }
};
</script>

<style scoped></style>
